import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { UserGroupMembershipShopItemsUpdateEvolution } from '@sorare/core/src/__generated__/globalTypes';
import { BrandL } from '@sorare/core/src/atoms/typography';

import type { ChampionshipStoryTitle_userGroupMembershipShopItemsUpdate } from './__generated__/index.graphql';

type Props = {
  userGroupMembershipShopItemUpdate: ChampionshipStoryTitle_userGroupMembershipShopItemsUpdate;
};
export const ChampionshipStoryTitle = ({
  userGroupMembershipShopItemUpdate,
}: Props) => {
  const { evolution, previousShopItems, newShopItems } =
    userGroupMembershipShopItemUpdate;

  const hasPreviousShopItems = !!previousShopItems.length;
  const hasNewShopItems = !!newShopItems.length;

  return (
    <BrandL className="text-center">
      {evolution === UserGroupMembershipShopItemsUpdateEvolution.NOVEL && (
        <FormattedMessage
          id="ChampionshipStoryTitle.earnPrestige"
          defaultMessage="You’ve earned a prestige rank"
        />
      )}
      {evolution === UserGroupMembershipShopItemsUpdateEvolution.BETTER && (
        <FormattedMessage
          id="ChampionshipStoryTitle.rankUp"
          defaultMessage="Your prestige rank went up!"
        />
      )}
      {evolution === UserGroupMembershipShopItemsUpdateEvolution.WORSE &&
        !!hasPreviousShopItems &&
        !!hasNewShopItems && (
          <FormattedMessage
            id="ChampionshipStoryTitle.rankDown"
            defaultMessage="Your prestige rank went down!"
          />
        )}
      {evolution === UserGroupMembershipShopItemsUpdateEvolution.WORSE &&
        !!hasPreviousShopItems &&
        !hasNewShopItems && (
          <FormattedMessage
            id="ChampionshipStoryTitle.lostPrestige"
            defaultMessage="You lost your prestige rank"
          />
        )}
    </BrandL>
  );
};

ChampionshipStoryTitle.fragments = {
  userGroupMembershipShopItemsUpdate: gql`
    fragment ChampionshipStoryTitle_userGroupMembershipShopItemsUpdate on UserGroupMembershipShopItemsUpdate {
      id
      evolution
      previousShopItems {
        id
      }
      newShopItems {
        id
      }
    }
  ` as TypedDocumentNode<ChampionshipStoryTitle_userGroupMembershipShopItemsUpdate>,
};
